import { AfterContentInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, viewChild } from '@angular/core';
import { Actions } from '@ngrx/effects';
import {
	loadVerfuegungenByVorgangAction,
	loadVerfuegungenByVorgangSuccessAction,
	VerfuegungFacade,
	VerfuegungLinkRel,
	VerfuegungResource,
	VerfuegungTyp,
} from '@schir-int-client/verfuegung-shared';
import {
	VorgangResource,
	VorgangTypLabel,
	VorgangTypLabelLFPR,
	VorgangTypLabelSchiff,
} from '@schir-int-client/vorgang-shared';
import { DialogService, HandlesBackdropClickAndEscapeKey, Spinner } from '@schir-int-client/tech';
import { Observable } from 'rxjs';
import { CreateVerfuegungDialogComponent } from './create-verfuegung-dialog/create-verfuegung-dialog.component';
import { map } from 'rxjs/operators';
import { CreateKorrespondenzVerfuegungDialogComponent } from './create-korrespondenz-verfuegung-dialog/create-korrespondenz-verfuegung-dialog.component';
import { ApiRootFacade } from '@schir-int-client/api-root';
import { CreateLfprVerfuegungDialogComponent } from './create-lfpr-verfuegung-dialog/create-lfpr-verfuegung-dialog.component';
import { ComponentType } from '@angular/cdk/overlay';

@Component({
	selector: 'schir-int-client-verfuegungen-in-vorgang',
	templateUrl: './verfuegungen-in-vorgang.component.html',
	styleUrls: ['./verfuegungen-in-vorgang.component.scss'],
	standalone: false,
})
export class VerfuegungenInVorgangComponent
	extends HandlesBackdropClickAndEscapeKey<
		CreateVerfuegungDialogComponent | CreateKorrespondenzVerfuegungDialogComponent
	>
	implements OnInit, OnChanges, AfterContentInit, OnDestroy
{
	@Input() vorgang: VorgangResource;
	readonly spinnerRef = viewChild<ElementRef>('spinner');

	verfuegungenInVorgang: Observable<VerfuegungResource[]>;
	korrespondenzVerfuegungenInVorgang: Observable<VerfuegungResource[]>;
	vorgangsTypen: VorgangTypLabel;

	private spinner: Spinner;

	constructor(
		private verfuegungFacade: VerfuegungFacade,
		private actions: Actions,
		protected dialogService: DialogService,
		private apiRootFacade: ApiRootFacade
	) {
		super(dialogService);
	}

	ngOnInit(): void {
		this.vorgangsTypen = this.apiRootFacade.isLFPR ? VorgangTypLabelLFPR : VorgangTypLabelSchiff;
	}

	ngOnChanges() {
		this.verfuegungenInVorgang = this.verfuegungFacade.verfuegungenByVorgang.pipe(
			map(verfuegungen => verfuegungen?.filter(verfuegung => verfuegung.typ == VerfuegungTyp.STANDARD))
		);
		this.korrespondenzVerfuegungenInVorgang = this.verfuegungFacade.verfuegungenByVorgang.pipe(
			map(verfuegungen => verfuegungen?.filter(verfuegung => verfuegung.typ == VerfuegungTyp.KORRESPONDENZ))
		);
	}

	ngAfterContentInit() {
		this.spinner = new Spinner(
			this.actions,
			loadVerfuegungenByVorgangAction.type,
			loadVerfuegungenByVorgangSuccessAction.type,
			this.spinnerRef()
		);
	}

	ngOnDestroy() {
		this.spinner.destroy();
	}

	openCreateVerfuegungDialog() {
		const editorType: ComponentType<any> = this.apiRootFacade.isLFPR
			? CreateLfprVerfuegungDialogComponent
			: CreateVerfuegungDialogComponent;
		this.dialogService.openEditorDialog(this, editorType);
	}

	openCreateKorrespondenzVerfuegungDialog() {
		this.dialogService.openEditorDialog(this, CreateKorrespondenzVerfuegungDialogComponent);
	}

	protected readonly linkRel = VerfuegungLinkRel;
}
